import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "async-content" */
    /* webpackPreload: true */
    './AsyncContent.js'
  ),
  LoadingComponent: () => <div className="async-content-placeholder" />,
  serverMode: 'defer'
});
